import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardHeader, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import AddEditPageModal from './Add_Edit/AddEditPageModal';
import DeletePageModal from './Delete/DeletePage';
import { getPageList } from '../../../../slices/thunks';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';

const PagesList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorPages = createSelector(
		state => state.Screen,
		page => ({
			pageList: page.pageList,
			isLoadingList: page.isLoadingList,
			isPageSuccess: page.isPageSuccess,
			error: page.error,
			isAdding: page.isAdding,
			isAdded: page.isAdded,
			isAddError: page.isAddError,
			isUpdating: page.isUpdating,
			isUpdated: page.isUpdated,
			isUpdateError: page.isUpdateError,
			isDeleting: page.isDeleting,
			isDeleted: page.isDeleted,
			isDeleteError: page.isDeleteError,
		})
	);

	const { pageList, isLoadingList } = useSelector(selectorPages);

	useEffect(() => {
		dispatch(getPageList());
	}, []);

	const [dataPage, setDataPage] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	const [modal, setModal] = useState(false);
	const [modalArticle, setModalArticle] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalArticle() {
		setModalArticle(!modalArticle);
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = page => {
		setDataPage(page);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = page => {
		setDataPage(page);
		handleToggleModal();
	};

	// Article
	const handleClickEdiArticle = page => {
		setDataPage(page);
		handleToggleModalArticle();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'page',
				columnDefType: 'display',
				 width: 10,
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const pageData = cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(pageData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const pageData = cellProps.row.original;
													handleClickDelete(pageData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Nombre', accessorKey: 'name',  size: 'auto', },
			{ header: 'Decripción', accessorKey: 'description',  size: 'auto', },
			{ header: 'Tipo', accessorKey: 'page_type.name',  size: 'auto', },

		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						<CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataPage({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Página
										</button>
									</div>
								</div>
							</div>
						</CardHeader>
						<CardBody>
							<ODataGrid
								columns={columns}
								data={pageList || []}
								isLoadingData={isLoadingList}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataPage({});
											handleToggleModal();
										},
										title: 'Crear Página'
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditPageModal
				dataPage={dataPage}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
			// activeTab={activeTab}
			// toggleTab={toggleTab}
			/>

			<DeletePageModal
				dataPage={dataPage}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default PagesList;
